import type { PlannerUIMessage } from './types';

// A reply that continues after a card writes a new text part, so each part is its own paragraph.
export const messageText = (message: PlannerUIMessage): string =>
  (message.parts ?? [])
    .flatMap((part) => (part.type === 'text' && part.text.trim() ? [part.text.trim()] : []))
    .join('\n\n');
